import { ReactNode } from 'react';

/** @todo: If necessary, provide styles for the "b" tag */
const important = (content: ReactNode) => <b>{content}</b>;

export { important };
